import React from "react"
import * as Yup from "yup"
import { useDispatch, useSelector } from "react-redux"
import {
  Container,
  Row,
  Col,
  Spinner,
  Card,
  CardBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import {
  addUsers,
  getAuthor,
  getCraftsman,
  onCheckedAuthor,
  onCheckedCraftsman,
} from "store/actions"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useFormik } from "formik"
import { useHistory } from "react-router-dom"
import BackButton from "components/Common/BackButton"
import SButton from "components/Common/Button"

const ModalCreateUser = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(({ Users }) => Users)
  const [field, setField] = React.useState({
    authority: "",
    craftsmanTypes: [],
  })

  const refetchData = () => {
    setField({
      authority: "",
      craftsmanTypes: [],
    })
    history.push("/administrator")
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: "",
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("必須項目です。"),
      email: Yup.string().required("必須項目です。"),
    }),
    onSubmit: values => {
      let payload = { ...values }
      payload.authority = field.authority
      payload.confirmPassword = values.password
      let _craftsman = []
      store.craftsman.map(item => {
        if (item.isChecked) {
          _craftsman.push(item.label)
        }
      })
      payload.craftsmanTypes = _craftsman
      dispatch(addUsers(payload, refetchData))
    },
  })

  const onChange = (e, i) => {
    let { name, value, checked } = e.target
    let args = { index: i, checked: checked }
    if (name === "authority") {
      setField({ ...field, authority: value })
      dispatch(onCheckedAuthor(args))
    } else if (name === "craftsmanTypes") {
      dispatch(onCheckedCraftsman(args))
    } else {
      setField({ ...field, [name]: value })
    }
  }

  React.useEffect(() => {
    dispatch(getAuthor())
    dispatch(getCraftsman())
  }, [dispatch, store.status])

  return (
    <div className="page-content">
      <Form
        onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
      >
        <Container fluid>
          <Breadcrumbs title={"管理者"} breadcrumbList={[]} />
          <Card>
            <CardBody>
              <Row>
                <Col md={8}>
                  <p className="fw-bold">新規管理者追加</p>
                </Col>
                <Col className="d-flex justify-content-end">
                  <SButton
                    disabled={store.status === "creating"}
                    className="button"
                    type="submit"
                  >
                    {store.status === "creating" ? (
                      <Spinner size="sm" color="light" />
                    ) : (
                      "保存"
                    )}
                  </SButton>
                  <BackButton className="ms-2 button" />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md="12">
                  <Label className="form-label">
                    名前<span className="text-danger">*</span>
                  </Label>
                  <Input
                    placeholder=""
                    type="text"
                    name="name"
                    className="form-control"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col md="12" className="mt-3">
                  <Label className="form-label">
                    メールアドレス<span className="text-danger">*</span>
                  </Label>
                  <Input
                    placeholder=""
                    type="text"
                    name="email"
                    className="form-control"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email
                        ? true
                        : false
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">
                      {validation.errors.email}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col md="12" className="mt-3">
                  <Label className="form-label">パスワード</Label>
                  <Input
                    placeholder=""
                    type="password"
                    name="password"
                    className="form-control"
                    onChange={validation.handleChange}
                    value={validation.values.password || ""}
                  />
                </Col>
                <Col md="12" className="mt-3">
                  <label className="form-label">権限</label>
                  <div className="d-flex">
                    {store?.author.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="d-flex align-items-center me-3"
                        >
                          <input
                            type="radio"
                            defaultChecked={item.isChecked}
                            value={item.label}
                            name="authority"
                            onChange={e => onChange(e, index)}
                          />
                          <label className="form-label mb-0 ms-2">
                            {item.label}
                          </label>
                        </div>
                      )
                    })}
                  </div>
                </Col>
                <Col md="12" className="mt-3">
                  <label className="form-label">職人種類</label>
                  <div className="d-flex">
                    {store?.craftsman.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="d-flex align-items-center me-3"
                        >
                          <input
                            onChange={e => onChange(e, index)}
                            name="craftsmanTypes"
                            type="checkbox"
                            defaultChecked={item.isChecked}
                          />
                          <label className="form-label mb-0 ms-2">
                            {item.label}
                          </label>
                        </div>
                      )
                    })}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </Form>
    </div>
  )
}

export default ModalCreateUser
